import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/gossip";

const quicks = [
  { label: "全部瓜料", to: "/category" },
  { label: "娱乐爆料", to: "/category/yule" },
  { label: "网红动态", to: "/category/wanghong" },
  { label: "影视综艺", to: "/category/yingshi" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setFormError("");
      form.reset();
      return;
    }

    setStatus("loading");
    setFormError("");

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      const text = String(value).trim();
      if (!text) return;
      payload.append(key, text);
    });

    try {
      const response = await fetch("https://readdy.ai/api/form/dahflqboh653ivfvntgg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = /spam/i.test(String(serverMsg));

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请检查连接后重试。");
    }
  };

  return (
    <footer id="subscribe" className="w-full bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-fire-line" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-bold text-lg text-background-50 tracking-wide">
                  {siteInfo.brand}
                </span>
                <span className="text-[10px] tracking-[0.18em] text-background-400 font-label mt-0.5">
                  {siteInfo.sloganEn}
                </span>
              </span>
            </Link>
            <p className="mt-5 text-sm leading-relaxed text-background-300 max-w-md">
              {siteInfo.intro}
            </p>
            <div className="mt-6 flex items-center gap-2 text-sm text-background-300">
              <span className="w-8 h-8 rounded-md bg-background-50/10 flex items-center justify-center">
                <i className="ri-mail-line" aria-hidden="true"></i>
              </span>
              {siteInfo.email}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-base font-semibold text-background-50">热门分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-base font-semibold text-background-50">快速链接</h3>
            <ul className="mt-4 space-y-2.5">
              {quicks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-heading text-base font-semibold text-background-50">订阅热瓜更新提醒</h3>
            <p className="mt-3 text-sm text-background-300">
              留下邮箱，有新瓜料与热榜变化时第一时间通知你。
            </p>
            <form id="dahflqboh653ivfvntgg" data-readdy-form onSubmit={handleSubmit} className="mt-4" noValidate>
              <input
                type="text"
                name="website_alt"
                className="form-hp-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <div className="flex flex-col sm:flex-row gap-2.5">
                <label htmlFor="sub-email" className="sr-only">
                  邮箱地址
                </label>
                <input
                  id="sub-email"
                  type="email"
                  name="email"
                  required
                  placeholder="请输入你的邮箱"
                  className="flex-1 min-w-0 px-4 py-3 rounded-md bg-background-50/10 border border-background-50/20 text-sm text-background-50 placeholder:text-background-400 focus:outline-none focus:ring-2 focus:ring-accent-400 focus:border-accent-400"
                />
                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="px-5 py-3 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap disabled:opacity-60 cursor-pointer"
                >
                  {status === "loading" ? "提交中…" : "立即订阅"}
                </button>
              </div>
              {status === "success" && (
                <p className="mt-3 text-sm text-accent-300 flex items-center gap-1.5">
                  <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
                  订阅成功，热瓜更新我们会第一时间通知你。
                </p>
              )}
              {status === "error" && (
                <p className="mt-3 text-sm text-primary-300 flex items-center gap-1.5">
                  <i className="ri-error-warning-line" aria-hidden="true"></i>
                  {formError}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 {siteInfo.brand} · 本站内容整理自网络公开信息，仅供浏览参考
          </p>
          <div className="flex items-center gap-3 text-xs text-background-400">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line" aria-hidden="true"></i>
              内容合规审核
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-information-line" aria-hidden="true"></i>
              理性吃瓜
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}